const COOKIE_NAME = "matomo_session_id";
const COOKIE_MAX_AGE = 365 * 24 * 60 * 60; // 1 year in seconds

function generateSessionId() {
  let hex = "";
  for (let i = 0; i < 16; i++) {
    hex += Math.floor(Math.random() * 16).toString(16);
  }
  return hex;
}

export function getOrCreateMatomoSessionId() {
  if (typeof document === "undefined") return undefined;
  const cookies = document.cookie.split(";").map((c) => c.trim());
  let sessionId = cookies.find((c) => c.startsWith(COOKIE_NAME + "="));
  if (sessionId) {
    return sessionId.split("=")[1];
  }

  sessionId = generateSessionId();

  document.cookie = `${COOKIE_NAME}=${sessionId}; Path=/; Max-Age=${COOKIE_MAX_AGE}; SameSite=Lax;`;
  return sessionId;
}
